
(($) => {
    'use strict'

    const $iconPicker = $('.icp');
    if ($iconPicker.length === null) {
        return;
    }

    const options = {
        title: false,
        selected: false,
        defaultValue: false,
        placement: 'bottom',
        collision: 'none',
        animation: false,
        hideOnSelect: true,
        selectedCustomClass: 'bg-primary',
        icons: require('../json/icons.json'),
        input: 'input,.iconpicker-input',
        inputSearch: true
    };

    const iconElementInput = document.getElementById('icon-picker-preview');
    $iconPicker.iconpicker(options).on('iconpickerSelected', function (event) {
        console.log(event.iconpickerValue)
        if (iconElementInput.innerHTML !== '') {
            iconElementInput.innerHTML = '';
        }
        iconElementInput.className = `text-xl`;
        iconElementInput.innerHTML = `<i class="${event.iconpickerValue}"></i>`;
    });

})($);
